"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractNumberStatuses = exports.transformFilterParamsToUrl = exports.transformContractNumbersParamsToFilterParams = exports.transformUrlToContractNumbersFilterParams = exports.transformContractNumberParams = void 0;
const types_1 = require("api/references/contractNumber/types");
const helper_1 = require("src/modules/common/helper");
const queryString_1 = require("core/helpers/queryString");
const transformContractNumberParams = (params) => {
    return {
        number: params.number,
        dateOfPreparation: (0, helper_1.nullableTransformParamsDate)(params.dateOfPreparation),
        userId: params.purchaser?.id || null,
        isBooked: params.isBooked
    };
};
exports.transformContractNumberParams = transformContractNumberParams;
const transformUrlToContractNumbersFilterParams = (url) => {
    const values = (0, queryString_1.parse)(url);
    return {
        page: values.page,
        perPage: values.perPage,
        keyword: values.keyword,
        status: values.statusIds?.map((el, index) => ({ id: el, label: (values.statusLabels && values.statusLabels[index]) })),
        dateOfPreparationFrom: values.dateOfPreparationFrom,
        dateOfPreparationTo: values.dateOfPreparationTo
    };
};
exports.transformUrlToContractNumbersFilterParams = transformUrlToContractNumbersFilterParams;
const transformContractNumbersParamsToFilterParams = (params) => {
    const filters = {};
    const paginate = {};
    const filterParams = {
        keyword: params.keyword,
        status: params.status && Array.isArray(params.status)
            ? params.status.map(status => Number(status.id))
            : undefined,
        dateOfPreparationFrom: params.dateOfPreparationFrom,
        dateOfPreparationTo: params.dateOfPreparationTo,
        page: params.page,
        perPage: params.perPage
    };
    try {
        Object.entries(filterParams).map(([key, value]) => {
            if (value && key !== 'page' && key !== 'perPage')
                filters[key] = value;
            if (value && (key === 'page' || key === 'perPage'))
                paginate[key] = value;
        });
        if (Object.keys(filters).length === 0)
            return { ...paginate };
        return { ...paginate, filters };
    }
    catch (err) {
        console.error({ err });
        return {};
    }
};
exports.transformContractNumbersParamsToFilterParams = transformContractNumbersParamsToFilterParams;
const transformFilterParamsToUrl = (values) => {
    const { keyword, status, dateOfPreparationFrom, dateOfPreparationTo, page, perPage } = values;
    return {
        keyword: keyword,
        statusIds: status && status.map(el => el.id),
        statusLabels: status && status.map(el => el.label),
        dateOfPreparationTo: dateOfPreparationFrom,
        dateOfPreparationFrom: dateOfPreparationTo,
        page,
        perPage
    };
};
exports.transformFilterParamsToUrl = transformFilterParamsToUrl;
exports.contractNumberStatuses = [
    { id: String(types_1.ContractNumberStatus.FREE), label: 'თავისუფალი' },
    { id: String(types_1.ContractNumberStatus.USED), label: 'დაკავებული' },
    { id: String(types_1.ContractNumberStatus.BOOKED), label: 'დაჯავშნილი' },
    { id: String(types_1.ContractNumberStatus.DECLINED), label: 'უარყოფილი' },
    { id: String(types_1.ContractNumberStatus.CANCELED), label: 'გაუქმებული' },
    { id: String(types_1.ContractNumberStatus.RETURNED), label: 'დაბრუნებული' }
];
